<script>
import ListingModel from "@/views/Evaluation/File/Components/ListingModel.vue"

export default {
    components: {ListingModel}
}
</script>

<template>
    <ListingModel
        type="EVALUATION_SKILL"
        root-path="evaluation_skill_goal_files"
    />
</template>